export function isTypescriptObject<T extends object>(value: any): value is T  {
  return typeof value === 'object' && value !== null
}

export function isNotNullOrUndefined<T>(value: any): value is T {
  return value !== null && value !== undefined;
}

export function isNullOrUndefined(value: any): value is null | undefined {
  return value === null || value === undefined;
}


